export enum PulpStatus {
  waiting = 'waiting',
  skipped = 'skipped',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
  canceled = 'canceled',
}
